<!---------------------------->
<!-- STEP: Association:-->
<!---------------------------->

<form [formGroup]="formGroup">

  <!-- Row-0 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <!--Processing Class disabled for both Add/Edit -->
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Processing Class</mat-label>
        <input [formControl]="processingClassFormControl" type="text" matInput readonly>
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Processing Class')">
        help_outline
      </mat-icon>
    </mat-grid-tile>

    <!--Case Name-->
    <mat-grid-tile>
      <mat-form-field>
        <mat-label>Case Name</mat-label>
        <input [formControl]="caseNameFormControl" type="text" matInput required
               (input)="onUpdateCaseName($event)">
        <span matSuffix>{{getCaseNameSuffix()}}</span>
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Case Name')">
        help_outline
      </mat-icon>
    </mat-grid-tile>
		<!--ICD Category-->
		<mat-grid-tile *ngIf="type === caseType.Funeral">
			<mat-form-field>
				<mat-label>ICD Category</mat-label>
				<input required matInput type="text"
							 [placeholder]="getInfoTooltip('ICD Category')"
							 [formControl]="icdCategoryNameFormControl"
							 (blur)="onBlurICDCategory()"
							 (input)="icdCategoryTextChanged$.next($any($event.target).value)"
							 [matAutocomplete]="icdCategoryAuto">
				<mat-autocomplete #icdCategoryAuto="matAutocomplete" [panelWidth]="'40vw'">
					<mat-option *ngFor="let icdCategory of icdCategories"
											[value]="icdCategory.name"
											(onSelectionChange)="onICDCategorySelectionChange($event.source.value)">
						{{icdCategory.name}}
					</mat-option>
				</mat-autocomplete>
				<button *ngIf="icdCategoryNameFormControl.value" (click)="icdCategoryNameFormControl.reset()"
								aria-label="Clear" mat-button mat-icon-button matSuffix>
					<mat-icon style="color: grey;">clear</mat-icon>
				</button>
			</mat-form-field>
			<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('ICD Category Name')">help_outline</mat-icon>
		</mat-grid-tile>
	</mat-grid-list>

  <!-- Row-1-->
  <mat-grid-list cols="3" rowHeight="75px">
    <mat-grid-tile>
      <div class="member-or-policy-radio-group">
        <mat-radio-group formControlName="memberOrPolicy"
                         [name]="'memberOrPolicyRadioGroup'"
                         (change)="onMemberOrPolicyRadioOptionValueChanged($event)">
          <mat-radio-button class="m-b-5" [value]="searchType.MEMBER">
            {{searchType.MEMBER}}
          </mat-radio-button>
          <mat-radio-button class="m-b-5" [value]="searchType.POLICY">
            {{searchType.POLICY}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Member Last Name Autocomplete -->
      <mat-form-field class="w-50" *ngIf="formGroup.get(controls.MEMBER_OR_POLICY).value === searchType.MEMBER">
        <mat-label>Member Last Name</mat-label>
        <input required matInput type="text"
               [placeholder]="getInfoTooltip('Member Last Name')"
               [formControl]="insuredPersonNameFormControl"
               (input)="insuredPersonNameTextChanged$.next($any($event.target).value)"
               (blur)="onBlurInsuredPersonName()"
               [matAutocomplete]="insuredPersonAuto">
        <mat-autocomplete #insuredPersonAuto="matAutocomplete" [panelWidth]="'40vw'">
          <mat-option (onSelectionChange)="onInsuredPersonSelected($event.source.value)"
                      *ngFor="let insuredPerson of filteredInsuredPersons"
                      [value]="insuredPerson.displayValue"
                      class="custom-mat-option">
            {{insuredPerson.displayValue}}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="insuredPersonNameFormControl.value" aria-label="Clear"
                mat-button mat-icon-button matSuffix
                (click)="resetDependentLinkedPoliciesAndProducts()">
          <mat-icon style="color: grey;">clear</mat-icon>
        </button>
      </mat-form-field>

      <!-- Member Dropdown List -->
      <mat-form-field class="w-50" *ngIf="formGroup.get(controls.MEMBER_OR_POLICY).value === searchType.POLICY">
        <mat-label>Member</mat-label>
        <mat-select [formControl]="insuredPersonNameFormControl" required
                    (selectionChange)="onInsuredPersonSelected($event.source.value)">
          <mat-option *ngFor="let insuredPerson of filteredInsuredPersons"
                      [value]="insuredPerson.displayValue">
            {{insuredPerson.displayValue}}
          </mat-option>
        </mat-select>
        <button (click)="clearInsuredPersonName(); clearProduct();" *ngIf="insuredPersonNameFormControl.value"
                aria-label="Clear"
                mat-button mat-icon-button matSuffix>
          <mat-icon style="color: grey;">clear</mat-icon>
        </button>
      </mat-form-field>
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Member Drop Down')">help_outline</mat-icon>
    </mat-grid-tile>

    <mat-grid-tile>
      <!-- Policy Dropdown List -->
      <mat-form-field
        *ngIf="formGroup.get(controls.MEMBER_OR_POLICY).value === searchType.MEMBER">
        <mat-label>Policy</mat-label>
        <mat-select [formControl]="policyFormControl" required
                    (selectionChange)="onPolicySelected($event.source.value)">
          <mat-option *ngFor="let policy of filteredPolicies" [value]="getPolicyDisplayString(policy)">
            {{getPolicyDisplayString(policy)}}
          </mat-option>
        </mat-select>
        <button *ngIf="policyFormControl.value" aria-label="Clear" mat-button mat-icon-button matSuffix
                (click)="resetLinkedPoliciesAndProducts()">
          <mat-icon style="color: grey;">clear</mat-icon>
        </button>
      </mat-form-field>

      <!-- Policy Number Autocomplete -->
      <mat-form-field
        *ngIf="formGroup.get(controls.MEMBER_OR_POLICY).value === searchType.POLICY">
        <mat-label>Policy Number</mat-label>
        <input required matInput type="text"
               [placeholder]="getInfoTooltip('Policy Number')"
               [formControl]="policyFormControl"
               (input)="policyNumberTextChanged$.next($any($event.target).value)"
               (blur)="onBlurPolicyNumber()"
               [matAutocomplete]="policyAuto">
        <mat-autocomplete #policyAuto="matAutocomplete" [panelWidth]="'40vw'">
          <mat-option (onSelectionChange)="onPolicySelected($event.source.value)"
                      *ngFor="let policy of filteredPolicies"
                      [value]="getPolicyDisplayString(policy)"
                      class="custom-mat-option">
            {{getPolicyDisplayString(policy)}}
          </mat-option>
        </mat-autocomplete>
        <button *ngIf="policyFormControl.value" aria-label="Clear"
                mat-button mat-icon-button matSuffix
                (click)="resetDependentLinkedPoliciesAndProducts()">
          <mat-icon style="color: grey;">clear</mat-icon>
        </button>
      </mat-form-field>


			<ng-container *ngIf="formGroup.get(controls.MEMBER_OR_POLICY).value === searchType.MEMBER; else showPolicyToolTipInfo">
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policy Name')">help_outline</mat-icon>
			</ng-container>

			<ng-template #showPolicyToolTipInfo>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policy Number')">help_outline</mat-icon>
			</ng-template>

    </mat-grid-tile>

		<!--Products not exists -->
		<mat-grid-tile *ngIf="isPersonAndPolicySelected && !hasProducts; else showProductDropdown">
			<mat-label  class="mat-primary-color">No {{type}} products are associated to this policy</mat-label>
		</mat-grid-tile>

		<ng-template #showProductDropdown>
			<mat-grid-tile>
				<mat-form-field>
					<mat-label>Product</mat-label>
					<mat-select [formControl]="productFormControl" required
											(selectionChange)="onProductSelected($event.source.value)">
						<mat-option *ngFor="let product of products" [value]="product.productId">
              {{products.length > 1 ? getProductDisplayName(product) : product.name}}
						</mat-option>
					</mat-select>
					<button *ngIf="productFormControl.value" aria-label="Clear"
									mat-button mat-icon-button matSuffix
									(click)="clearProduct()">
						<mat-icon style="color: grey;">clear</mat-icon>
					</button>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Product Name')">help_outline</mat-icon>
			</mat-grid-tile>
		</ng-template>

  </mat-grid-list>

  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPerson"
                         [content]="getInsuredPersonNameDisplayString(selectedInsuredPerson)"
                         [label]="'Member Name'">
      </app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy"
                         [content]="selectedPolicy.name"
                         [label]="'Policy Name'"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected">
      <app-content-field *ngIf="selectedProduct"
                         [content]="selectedProduct.name"
                         [label]="'Product Name'"></app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-2 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPerson" [label]="'Member Number'"
                         [content]="selectedInsuredPerson.cardNumber"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Policy Number'"
                         [content]="selectedPolicy.number"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected && hasProducts">
      <app-content-field *ngIf="selectedProduct" [label]="'Product Code'"
                         [content]="selectedProduct.productCode"></app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-3 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPerson" [label]="'Association'"
                         [content]="getAssociationDisplayString(selectedInsuredPerson)"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Policyholder'"
                         [content]="selectedPolicy.policyholder.name"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected && hasProducts">
      <app-content-field *ngIf="selectedProduct" [label]="'Processing Class'"
                         [content]="selectedProduct.processingClass.name"></app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-4 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPerson" [label]="'Date of Birth'"
                         [content]="selectedInsuredPerson.dateOfBirth | date: dateFormat"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Administrator'"
                         [content]="selectedPolicy.administrator?.name"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected && hasProducts">
      <app-content-field *ngIf="selectedProduct" [label]="'Booking Days'"
                         [content]="selectedProduct.bookingDays"></app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-5 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPerson" [label]="'Gender'"
                         [content]="selectedInsuredPerson.gender.name"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Payer Name'"
                         [content]="selectedPolicy.payer.name"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected && hasProducts">
			<app-content-field *ngIf="selectedProduct" [label]="'Provider Network'"
												 [content]="selectedProduct.providerNetwork.name"></app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-6 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPersonWithDates"
                         [label]="'Member Start - End Dates for Selected Policy'"
                         [content]="createDateRangeString(
                               selectedInsuredPersonWithDates.startDate,
                               selectedInsuredPersonWithDates.endDate)">
      </app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Policy Start - End Dates'"
                         [content]="createDateRangeString(selectedPolicy.startDate, selectedPolicy.endDate)">
      </app-content-field>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="isPersonAndPolicySelected && hasProducts">
      <app-content-field *ngIf="selectedProduct" [label]="'Product Start - End Dates'"
                         [content]="createDateRangeString(selectedProduct.startDate, selectedProduct.endDate)">
      </app-content-field>
    </mat-grid-tile>

  </mat-grid-list>

  <!-- Row-7 -->
  <mat-grid-list cols="3" rowHeight="75px">
    <mat-grid-tile>
      <app-content-field *ngIf="selectedInsuredPersonWithDates" [label]="'Current Member Cover Status'"
                         [content]="selectedInsuredPersonWithDates.coverStatus != null
                               ? selectedInsuredPersonWithDates.coverStatus.name
                               : ''"></app-content-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <app-content-field *ngIf="selectedPolicy" [label]="'Current Policy Cover Status'"
                         [content]="selectedPolicy.status">
      </app-content-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <!-- Row-8 -->
  <mat-grid-list cols="3" rowHeight="75px">

    <mat-grid-tile>
      <!-- Content Field -->
      <app-content-field *ngIf="selectedInsuredPerson && !editIdNumber" [label]="'National ID Number'"
                         [content]="selectedInsuredPerson.nationalIdNumber | slice:0:13"
                         [isEditable]="allowOverride()" (editClick)="overrideIdNumberClicked($event)"></app-content-field>

      <!-- Input Field -->
      <mat-form-field *ngIf="selectedInsuredPerson && editIdNumber">
        <mat-label>National ID Number</mat-label>
        <input [formControl]="idNumberOverrideFormControl" matInput required>
        <button (click)="showIdNumberContentField()" aria-label="Clear"
                mat-button mat-icon-button matSuffix style="margin-left: 16px; margin-right: -12px">
          <mat-icon style="color: grey;" matTooltip="Clear input">clear</mat-icon>
        </button>
        <button (click)="saveIdNumberOverride()" aria-label="save"
                mat-button mat-icon-button matSuffix>
          <mat-icon class="table-icon" matTooltip="Save input">save</mat-icon>
        </button>
        <mat-hint>Ensure the override is saved or cancelled using the icons</mat-hint>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>


  <div class="button-container">
    <button mat-raised-button color="warn" (click)="resetAssociationFormGroup();">Clear</button>
    <button mat-raised-button matStepperNext color="primary">Next</button>
  </div>
</form>
